import { resolveMediaUrl } from './mediaUrl';

export const parseSolutionsHeroContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const heroSection = page.sections.find((section) => section.key === 'hero');
  if (!heroSection) {
    return null;
  }

  const fields = heroSection.fields || {};
  const backgroundMedia =
    heroSection.media?.primary ||
    heroSection.media?.groups?.background?.[0] ||
    null;

  if (!backgroundMedia?.url || !fields.title) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow || '',
    title: fields.title,
    text: fields.text || '',
    backgroundImage: resolveMediaUrl(backgroundMedia.url),
  };
};
